export enum PaymentMethodEnum {
  CB = 'CB',
  SEPA = 'SEPA',
  OFFLINE = 'OFFLINE',
  INIT_TRANSFERT_IMMEDIATE = 'INIT_TRANSFERT_IMMEDIATE',
  INIT_TRANSFERT_DEFERRED = 'INIT_TRANSFERT_DEFERRED',
}
